import React, { useEffect, useState } from "react";
import { Card, Button, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useSurveySrv } from "pages/Survey/useSurveySrv";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import i18n from "i18next";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import { useNavigate, useLocation } from "react-router-dom";
import { portalActions } from "store/portal-slice";
import { useDispatch } from "react-redux";
import { clearLocalStore } from "helpers/localStoreSrv";
import { Grid, theme } from "antd";
import BrandColors from "@brand-colors";
import { LANGUAGES } from "./../../constants/supported_lang";
import ReactGA from "react-ga";
import whitelabelConfig from "@whitelabel-config";
import { useMemberActivityListSrv } from "pages/Survey/useMemberActivityListSrv";

const { Title } = Typography;
const { useToken } = theme;
const { useBreakpoint } = Grid;
const MemberPortalAgreement = () => {
  const location = useLocation();
  const [cnfmText, setCnfmText] = useState("");
   const [surveyList, setSurveyList] = useState();
  const uiState = useSelector((state: any) => state.portal.uiState);
  const agreementText = location.state && location.state.agreementText;
  const renderHtml = location.state && location.state.renderHtml;
 // const languageConfirmed = location.state && location.state.languageConfirmed;
  const languageConfirmed =
    sessionStorage.getItem("languageConfirmed");
  console.log("languageConfirmed", languageConfirmed);
  const memberLanguage = useSelector(
    (state: any) => state.portal.uiState.Language
  );

  const { rawSurveyData } = location.state;
     const languageCode = LANGUAGES.find(
       (lang) => lang.id === rawSurveyData.PreferredLanguage
     );
  console.log("from", rawSurveyData.PreferredLanguage);
  console.log("rawSurveyDataAgreement", rawSurveyData);
    const [surveyLanguage, setSurveyLanguage] = useState(
      languageCode?.code || "en"
    );
      const [rueBasedActivities, setrueBasedActivities] = useState();
  const { getLanguageTranslations } = useSurveySrv();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const usState = useSelector((state: any) => state.portal.uiState);
  const authState = useSelector((state: any) => state.portal.authSession);
  console.log("agreement_global api", usState.agreementState);
  const navigate = useNavigate();
  const { httpGetMemberActivities, mergeSurveyJson } =
    useMemberActivityListSrv();
  const { token } = useToken();
  const screens = useBreakpoint();
  // const preferredLanguageForSurvey = useSelector(
  //   (state: any) => state.portal.uiState.Language
  // );
  //  const preferredLanguageForSurvey = localStorage.getItem(
  //    "preferredLanguageForSurvey"
  //  ) ?? "en";
  const getIdByName = (id: any) => {
    const language = LANGUAGES.find((lang) => lang.id === id);
    return language?.code || null;
  };
  const hasAnyResponseAnswered = (surveyData:any) => {
    return surveyData.surveyPages?.some((page:any) =>
      page.surveyQuestions?.some(
        (question:any) =>
          question.Response !== null && question.Response !== undefined
      )
    );
  };
    useEffect(() => {
      httpGetMemberActivities()
        ?.then((res) => {
          console.log("res", res);
          let surveyList = res.data.filter(function (item: any) {
            return item.IsRuleBasedSurvey == true;
          });
          console.log("surveyList................", surveyList);
          setSurveyList(surveyList);
          const language = LANGUAGES.find(
            (lang) => lang.id === surveyList[0].PreferredLanguage
          );
          setSurveyLanguage(language?.code || "en");
          console.log("language................", language?.code);
          var rueBasedActivitiesL = res.data
            .filter((item: any) => item.IsRuleBasedSurvey === true)
            .map((item: any) => item.TranslationGroupID);
          setrueBasedActivities(rueBasedActivitiesL);
        })
        .catch((e) => {
          handleErrorNavigation(e, navigate, t);
        });
    }, []);
  const isAnyAnswered = hasAnyResponseAnswered(rawSurveyData);
  console.log("isAnyAnswered", isAnyAnswered);
  //  const preferredLanguageForSurvey =
  //    rawSurveyData.PreferredLanguage !== 120000000
  //      ? getIdByName(rawSurveyData.PreferredLanguage)
  //      : memberLanguage;
  console.log("surveyLanguage*", surveyLanguage);
  console.log("isAnyAnswered*", isAnyAnswered, languageConfirmed);

  const preferredLanguageForSurvey =
    isAnyAnswered && languageConfirmed ? surveyLanguage : memberLanguage;
  console.log(
    "preferredLanguageForSurvey**********",
    preferredLanguageForSurvey
  );
  const [currentLanguage, setCurrentLanguage] = useState(
    preferredLanguageForSurvey
  );
  const [isRightAlign, setIsRightAlign] = useState(false);
  const [translation, setTranslation] = useState(() => i18n.getFixedT("en"));
  console.log("preferredLanguageForSurvey+++++", preferredLanguageForSurvey);
  const updateConfirmationsByLang = (
    confirmationText: any,
    langCode: any,
    langData: any
  ) => {
    const updatedLangData =
      langData.filter((item: any) => item.LanguageCode === langCode) || [];
    const match = updatedLangData.find(
      (item: any) => item.TextCode === confirmationText
    );
    return match ? match.TextValue : confirmationText;
  };

  // useEffect(() => {
  //   i18n.changeLanguage(uiState.Language);
  // }, []);
  // useEffect(() => {
  //   i18n.changeLanguage(preferredLanguageForSurvey);
  // }, []);
  useEffect(() => {
    const selectedLanguage = i18n.getFixedT(preferredLanguageForSurvey);
    setTranslation(() => selectedLanguage);
  }, []);

  useEffect(() => {
    try {
      if (
        whitelabelConfig.uiSettings.rightAlignedLanguage.includes(
          preferredLanguageForSurvey
        ) === true
      ) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e);
      handleErrorNavigation(e, navigate, t);
    }
  }, [isRightAlign, currentLanguage]);

  const getIdByCode = (code: string) => {
    const language = LANGUAGES.find((lang) => lang.code === code);
    return language?.id || null;
  };
  useEffect(() => {
    const fetchSurveyData = async () => {
      try {
        const languageData = await getLanguageTranslations(
          rawSurveyData.TranslationGroupID
        );
        console.log("languageData", languageData);
        setCurrentLanguage(preferredLanguageForSurvey);
        const languageCode = getIdByCode(preferredLanguageForSurvey);

        // if (rawSurveyData?.IsRuleBasedSurvey) {
        //   const surveyJson = await fetch(rawSurveyData?.SurveyUrl).then((res) =>
        //     res.json()
        //   );
        const translatedText = updateConfirmationsByLang(
          agreementText,
          languageCode,
          languageData.data
        );

        setCnfmText(translatedText);
        //}
      } catch (error) {
        handleErrorNavigation(error, navigate, t);
        console.error(
          "Error fetching survey data or TranslationGroupID",
          error
        );
      } finally {
      }
    };

    if (authState?.is_authenticated) {
      fetchSurveyData();
    } else {
      clearLocalStore();
      handleErrorNavigation(new Error("Unauthorized"), navigate, t);
    }
  }, [authState, navigate, t, currentLanguage]);
  const proceedAgreement = () => {
    console.log("from......", rawSurveyData.PreferredLanguage);
    dispatch(portalActions.updateAgreementStatus(true));
    navigate("/surveymemberportal", {
      state: {
        rawSurveyData: rawSurveyData,
        renderHtml: renderHtml,
        preferredLanguageForSurvey: preferredLanguageForSurvey,
        isAnyAnswered: isAnyAnswered,
      },
    });
  };
  useEffect(() => {
    ReactGA.event({
      category: "Agreement Page loaded ",
      action: "Success SecondLevel Auth",
      label: "Agreement Page",
    });

    if (!authState.is_authenticated) {
      const navParams = {
        state: {
          errorCode: "401",
          errorTitle: t("LANDING.UNAUTHORIZED_DEFAULT"),
          errorDescription: "",
        },
      };
      clearLocalStore();
      navigate("/error", navParams);
    }
  }, []);
  const styles = {
    section1: {
      alignItems: "center",
      //backgroundColor: BrandColors.HEADER_BG,
      display: "flex",
      fontSize: screens.md ? token.fontSizeHeading5 : token.fontSizeHeading5,
      //color: token.colorBgContainer,
      //padding: screens.md ? `15px` : "10px",
      borderRadius: "5px",
      margin: "0",
    },
    section: {
      alignItems: "center",
      backgroundColor: token.colorBgContainer,
      display: "flex",
      fontSize: screens.md ? token.fontSizeHeading5 : token.fontSizeHeading5,
      padding: screens.md ? `0` : "0px",
      marginTop: "15px",
    },
    section2: {
      alignItems: "center",
      backgroundColor: token.colorBgContainer,
      display: "flex",
      fontSize: screens.md ? token.fontSizeHeading5 : token.fontSizeHeading5,
      padding: screens.md ? `0` : "0px",
      marginTop: "15px",
      justifyContent: "end",
    },
    title1: {
      fontSize: screens.md ? token.fontSizeHeading5 : token.fontSizeHeading5,
      marginTop: "0",
      marginBottom: "0px",
      marginRight: "10px",
    },
    button: {
      backgroundColor: BrandColors.BUTTON_BG,
      borderRadius: "50px",
    },
  };

  return (
    <div className="row page-wrapper justify-content-md-center">
      <div className="col-md-12 col-sm-12 agreementpage">
        <Card
          className="hc-activity-group hls-container"
          bodyStyle={{ padding: 15 }}
        >
          <div className="card-body">
            <div style={styles.section1}>
              <div
                style={{
                  width: "100%",
                  textAlign: isRightAlign ? "right" : "left",
                }}
                dangerouslySetInnerHTML={{ __html: cnfmText }}
              />
            </div>
            <div style={styles.section}></div>
            <div style={styles.section2}>
              <Title style={styles.title1}>
                {usState.agreementState?.BUTTON_AGREE_LABLE
                  ? usState.agreementState?.BUTTON_AGREE_LABLE
                  : translation("AGREEMENT_GLOBAL.BUTTON_AGREE_LABLE")}
              </Title>
              <Button
                data-testid={"btn-forward1"}
                style={{ verticalAlign: "middle" }}
                type="primary"
                className="btn-fab1 btn-forward1"
                onClick={proceedAgreement}
                style={styles.button}
              >
                <ArrowRightOutlined />
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default MemberPortalAgreement;
